import type { UserRole } from '@rendimees24/shared-types';

/**
 * Where a signed-in user should land based on their role. Used by the unified
 * login screen and by route guards that bounce wrong-role users to their own
 * shell instead of /no-access.
 *
 * `worker` includes both the mobile WorkerApp and the responsive web shell at
 * /worker. Web is the fallback; primary is mobile.
 */
export function homeForRole(role: UserRole | null | undefined): string {
  switch (role) {
    case 'admin':
    case 'dispatcher':
    case 'finance':
      return '/';
    case 'client_user':
      return '/client';
    case 'worker':
      return '/worker';
    case 'partner_admin':
      return '/partner';
    default:
      return '/no-access';
  }
}
